import * as React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumb from "../Components/Breadcrumb";
import {  useLocation } from "react-router-dom";
import FacultyCard, { NonTeachingFacultyCard } from "../Components/FacultyCard";
import manoj from "../assets/Faculty/TeachingMCA/Prof.Dr.ManojSathe.png";
import bharati from "../assets/Faculty/TeachingMCA/Mrs.BharatiM.Ramageri.png";
// import maithili from "../assets/Faculty/TeachingMCA/Prof.DrMs.MaithiliArjunwadkar.png";
import maithili from "../assets/Faculty/TeachingMCA/mithili_new.png";
import gajanan from "../assets/Faculty/TeachingMCA/Prof.GajananMadhaoBadhe.png";
import leena from "../assets/Faculty/TeachingMCA/Prof.LeenaAmolDeshmukh.png";
import uma from "../assets/Faculty/TeachingMCA/Prof.UmaR.Patil.png";
import yogeshwari from "../assets/Faculty/TeachingMCA/Prof.YogeshwariAnandMahajan.png";

import newDirector from "../assets/Faculty/TeachingMCA/MIBS_newDirector.png";

import prashant from "../assets/Faculty/NonTeaching/Mr.PrashantMarkale.png";
import santosh from "../assets/Faculty/NonTeaching/Mr.SantoshBhanudasBagav.png";
import aruna from "../assets/Faculty/NonTeaching/Mrs.ArunaUmeshKawathekar.png";
import megha from "../assets/Faculty/NonTeaching/Mrs.MeghaS.Satav.png";
import swati from "../assets/Faculty/NonTeaching/Mrs.SwatiKantilalGadhave.png";
import akanksha from "../assets/Faculty/NonTeaching/Ms.AkankshaTodarmal.png";
import mrudula from "../assets/Faculty/NonTeaching/Ms.MrudulaJMadiwale.png";
import sneha from "../assets/Faculty/NonTeaching/Ms.SnehalRahulPadhye.png";

import darshan from "../assets/Faculty/TeachingMBA/Prof.DarshanSMejari.png";
import amruta from "../assets/Faculty/TeachingMBA/Prof.Dr.AmrutaMandarKhedkar.png";
import sudarshan from "../assets/Faculty/TeachingMBA/Prof.Sudarshan.A.Pawar.png";
import mandakini from "../assets/Faculty/TeachingMBA/Prof.Dr.Ms.MandakiniR.Bhosale.png";
import prasad from "../assets/Faculty/TeachingMBA/Prof.Dr.PrasadGhodke.png";
import madhuri from "../assets/Faculty/TeachingMBA/Prof.MadhuriDambal.png";
import mahesh from "../assets/Faculty/TeachingMBA/Prof.MaheshSalvi.png";
import manojYawalkar from "../assets/Faculty/TeachingMBA/Prof.ManojShriramYawalkar.png";
import komal from "../assets/Faculty/TeachingMBA/Prof.Mrs.KomalH.Apte.png";
import sonal from "../assets/Faculty/TeachingMBA/Prof.Ms.SonalS.Tejwani.png";
import neha from "../assets/Faculty/TeachingMBA/Prof.NehaR.Gupte.png";
import rupali from "../assets/Faculty/TeachingMBA/Prof.RupaliJadhav.png";
import smita from "../assets/Faculty/TeachingMBA/Prof_Smita.png";

import vaishanvi from "../assets/Faculty/TeachingBCA/vaishnavi_joshi.png";
import anil from "../assets/Faculty/TeachingBCA/anil_phalke.png";
import mahesh_sasane from "../assets/Faculty/TeachingBCA/mahesh_sasane.png";
import monica from "../assets/Faculty/TeachingBCA/monica_mali.png";
import shilpa from "../assets/Faculty/TeachingBCA/shilpa_rathod.png";

import gajanan_badhe from "../assets/Faculty/TeachingMCA/ganajan_badhe.png";
import leena_deshmukh from "../assets/Faculty/TeachingMCA/leena_deshmukh.png";
import nidhi_damle from "../assets/Faculty/TeachingMCA/nidhi_damle.png";

import anita_deshmane from "../assets/Faculty/NonTeaching/anita_deshmane.png";
import Santosh_bagav from "../assets/Faculty/NonTeaching/Santosh_bagav.png";
import swati_gadhve from "../assets/Faculty/NonTeaching/swati_gadhve.png";
import urmlia_patil from "../assets/Faculty/NonTeaching/urmlia_patil.png";
import sneha_padhey from "../assets/Faculty/NonTeaching/sneha_Padhe.png";


import neha_gupte  from "../assets/Faculty/TeachingMBA/neha_gupte.png";
import priyanka_sonavane  from "../assets/Faculty/TeachingMBA/priyanka_sonavane.png";
import smita_sonavane  from "../assets/Faculty/TeachingMBA/smita_sonavane.png";
import sudarshan_pawar  from "../assets/Faculty/TeachingMBA/sudarshan_pawar.png";

import { Copyright } from "@material-ui/icons";

// const sidemenus = [
//   {
//     title: "Teaching Staff MCA",
//     url: "/faculty/TeachingMCA",
//   },
//     {
//     title: "Teaching Staff BCA",
//     url: "/faculty/TeachingBCA",
//   },
//   {
//     title: "Teaching Staff MBA",
//     url: "/faculty/TeachingMBA",
//   },
//   {
//     title: "Non Teaching Staff",
//     url: "/faculty/nonTeaching",
//   },
// ];

// export default function Faculty(props) {
//   const [menuName, setName] = useState(props.pageName);
//   const [menuId, setId] = useState(props.pageId);

//   useEffect(() => {
//     let id = menuId.toString();
//     document.getElementById(id).setAttribute("class", "active-menu");

//     // Add d-none class for all divs
//     sidemenus.forEach((element) => {
//       let id = element.title.split(" ").join("").toString();
//       document.getElementById(id).classList.add("d-none");
//     });

//     // remove class d-none of particular div on click by getting Id
//     let divId = menuName.split(" ").join("").toString();
//     document.getElementById(divId).classList.remove("d-none");

//     // scroll top
//     window.scrollTo(0, 0);
//   }, [menuName, menuId]);

//   const handleClick = (event) => {
//     setName(event.currentTarget.textContent);
//     setId(event.currentTarget.id);

//     // Remove all class active-menu of '.sideMenu a' on click
//     const allWithClass = Array.from(document.querySelectorAll(".sideMenu a"));

//     allWithClass.forEach((element) => {
//       element.classList.remove("active-menu");
//     });
//   };

//   return (
//     <>
//       <Breadcrumb pageTitle={menuName} />
//       <div className="container mt-3">
//         <div className="row default-padding-bottom">
//           {/* Sidebar */}
//           <aside className="sideMenu col-lg-3">
//             <div className="scroll-div">
//               {sidemenus.map((menu, index) => {
//                 return (
//                   <Link
//                     key={index}
//                     id={index}
//                     onClick={handleClick}
//                     to={menu.url}
//                   >
//                     {" "}
//                     {menu.title}{" "}
//                   </Link>
//                 );
//               })}
//             </div>
//           </aside>
//           {/* content */}
//           <div className="col-lg-9">
//             <div className="px-lg-3 px-1">
//               {sidemenus.map((menu, index) => {
//                 return (
//                   <div
//                     id={menu.title.split(" ").join("").toString()}
//                     key={index}
//                   >
//                     {props.pageContent}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }



const sidemenus = [
  {
    title: "Teaching Staff MCA",
    url: "/faculty/TeachingMCA",
  },
  {
    title: "Teaching Staff BCA",
    url: "/faculty/TeachingBCA",
  },
  {
    title: "Teaching Staff MBA",
    url: "/faculty/TeachingMBA",
  },
  {
    title: "Non Teaching Staff",
    url: "/faculty/nonTeaching",
  },
];

export default function Faculty(props) {
  const location = useLocation();
  const [menuName, setName] = useState(props.pageName);

  // ✅ Sync menu with URL
  useEffect(() => {
    const currentMenu = sidemenus.find(
      (menu) => menu.url === location.pathname,
    );

    if (currentMenu) {
      setName(currentMenu.title);
    }

    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Breadcrumb pageTitle={menuName} />

      <div className="container mt-3">
        <div className="row default-padding-bottom">
          {/* Sidebar */}
          <aside className="sideMenu col-lg-3">
            <div className="scroll-div">
              {sidemenus.map((menu, index) => (
                <Link
                  key={index}
                  to={menu.url}
                  className={
                    location.pathname === menu.url ? "active-menu" : ""
                  }
                  style={{
                    display: "block",
                    padding: "10px 14px",
                    marginBottom: "8px",
                    borderRadius: "20px",
                    background:
                      location.pathname === menu.url ? "#dcdcdc" : "#f1f1f1",
                    textDecoration: "none",
                    color: "inherit",
                    fontSize: "14px",
                  }}
                >
                  {menu.title}
                </Link>
              ))}
            </div>
          </aside>

          {/* Content */}
          <div className="col-lg-9">
            <div className="px-lg-3 px-1">{props.pageContent}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export function TeachingMCA() {
  return (
    <div className="bg-light m-0 px-3 pb-3">
      <h5 className="title-text py-4">Teaching Faculty MCA</h5>
      <div>
        <div>
          <FacultyCard
            img={newDirector}
            name="Dr.Aruna Deoskar"
            designation="Director"
            qualification="Ph.D(Computer), M.C.A, B.Sc(Maths), Dip(E&Tc)"
            specialization="Computer Application and Management"
            // mailId="drmaithili.mibs@gmail.com"
            researchArea="Business Analytics, Data Science, Machine learning, Organization Behaviour, MIS, Business Management, ISA, QA&Software testing, Project Management, Organizational Management"
            totalExperience="29 Years"
            industryExperience="01 Years"
            teachingExperience="28 Years"
            papersPublished={{ total: 48, national: 34, international: 14 }}
            booksPublished={{ total: 12, national: 9, international: 3 }}
            researchGuidance={{
              // total: 6,
              completed: 6,
              pursuing: 2,
              patents: "5",
              // filed: 1,
              Copyright: 1,
            }}
            googleScholarId=""
          />
        </div>
        {/* <div>
          <FacultyCard
            img={maithili}
            name="Prof. Dr. Ms. Maithili Arjunwadkar"
            designation="Director"
            qualification="Ph.D(Computer Studies), MCA, B.Sc.(Electronics)"
            specialization="Computer Studies"
            // mailId="drmaithili.mibs@gmail.com"
            researchArea="Data Security, Blockchain, Cryptography, steganography, Digital Watermarking, Big Data Analytics, IOB"
            totalExperience="28.03 Years"
            industryExperience="3.3 Years"
            teachingExperience="25 Years"
            papersPublished={{ total: 24, national: 2, international: 22 }}
            booksPublished={{ total: 3, national: 1, international: 2 }}
            researchGuidance={{
              // total: 6,
              completed: 4,
              pursuing: 3,
              patents: "5 ( 2 Design granted)",
              // filed: 1,
              Copyright: 1,
            }}
            googleScholarId="https://scholar.google.com/citations?user=KCvacI4AAAAJ&hl=en"
          />
        </div> */}
        {/* <div>
          <FacultyCard
            img={manoj}
            name="Prof. Dr. Manoj Sathe"
            designation="Associate Professor"
            qualification="Ph.D (Computer Science), M.C.A, M.B.S, P.G.D.B.M."
            specialization="IT"
            mailId="sathe.manoj@gmail.com"
            researchArea="Data Science and Machine Learning"
            totalExperience="19 Years"
            industryExperience="1.5 Years"
            teachingExperience="18 Years"
            papersPublished={{ total: 10, national: 6, international: 4 }}
            booksPublished={{ total: 7, national: 3, international: 4 }}
            researchGuidance={{
              total: 0,
              completed: 0,
              pursuing: 0,
              patents: 2,
            }}
            googleScholarId="https://scholar.google.com/citations?user=ujcBVt4AAAAJ&hl=en"
          />
        </div> */}
        <div>
          <FacultyCard
            img={gajanan_badhe}
            name="Dr. Gajanan Madhao Badhe"
            designation="Asst. Professor & Controller of Examinations"
            qualification="Ph.D. (Computer Management), MCA, MMS (HRM), PGDBM, M.Sc. (Electronics), B.Sc. (Electronics) SET (Computer Sc. & Applications)"
            specialization="Computer Management"
            // mailId="gmbadhe@hotmail.com"
            researchArea="Data/Document Security and Management"
            totalExperience="27 Years"
            industryExperience="01 Years"
            teachingExperience="26 Years"
            papersPublished={{
              total: "09",
              national: "02",
              international: "07",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "02",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={bharati}
            name="Dr. Bharati M.Ramageri"
            designation="Assistant Professor"
            qualification="Ph.D, M.Tech, B.E"
            specialization="Data Mining, Data Warehousing, Security, Blockchain"
            // mailId="bharatiramageri@gmail.com"
            researchArea="Blockchain Technology"
            totalExperience="24 Years"
            industryExperience="02 Years"
            teachingExperience="22 Years"
            papersPublished={{
              total: "16",
              national: "08",
              international: "08",
            }}
            booksPublished={{ total: "01", national: "Nil", international: "01" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "03",
            }}
            googleScholarId="https://scholar.google.co.in/citations?user=0k1YlqMAAAAJ&hl=en"
          />
        </div>
        <div>
          <FacultyCard
            img={leena_deshmukh}
            name="Prof. Leena Amol Deshmukh"
            designation="Assistant Professor"
            qualification="Ph.D (Pursuing) , MCA, B.Sc (Computer Science), NET (computer Science and Applications)"
            specialization="Computer management"
            // mailId="leenavaidya2212@gmail.com"
            researchArea="Information Security"
            totalExperience="17 Years"
            industryExperience="Nil"
            teachingExperience="17 Years"
            papersPublished={{
              total: "02",
              national: "01",
              international: "01",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={uma}
            name="Dr. Uma R. Patil"
            designation="Assistant Professor"
            // designation="Director"
            qualification="Ph.D in Computer Science, MCA, M.Sc.(CS)"
            specialization="Computer Science"
            // mailId="ujupatil@gmail.com"
            researchArea="Internet of Things"
            totalExperience="16 Years"
            industryExperience="01 Years"
            teachingExperience="15 Years"
            papersPublished={{
              total: "10",
              national: "4",
              international: "6",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "03",
            }}
            googleScholarId="https://scholar.google.com/citations?user=20TVp14AAAAJ&hl=en"
          />
        </div>
        <div>
          <FacultyCard
            img={nidhi_damle}
            name="Prof. Nidhi Ninad Damle"
            designation=""
            qualification="M.C.A, BCA, D.CS"
            specialization="Computer Management"
            // mailId="ujupatil@gmail.com"
            researchArea="Data Analytics"
            totalExperience="6 Years"
            industryExperience="Nil"
            teachingExperience="06 Years"
            papersPublished={{
              total: "02",
              national: "02",
              international: "Nil",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        {/* <div>
          <FacultyCard
            img={yogeshwari}
            name="Prof.Yogeshwari Anand Mahajan"
            designation="Assistant Professor"
            qualification="MCA"
            specialization=""
            mailId="yogeshwariamahajan@gmail.com"
            researchArea=""
            totalExperience="2+"
            industryExperience=""
            teachingExperience=""
            papersPublished={{ total: 0, national: 0, international: 0 }}
            booksPublished={{ total: "Nil", national: 0, international: 0 }}
            researchGuidance={{
              total: 0,
              completed: 0,
              pursuing: 0,
              patents: "Nil",
            }}
            googleScholarId=""
          />
        </div> */}
      </div>
    </div>
  );
}

export function TeachingBCA() {
  return (
    <div className="bg-light m-0 px-3 pb-3">
      <h5 className="title-text py-4">Teaching Faculty BCA</h5>
      <div>
        <div>
          <FacultyCard
            img={vaishanvi}
            name="Prof. Vaishnavi Joshi"
            designation="Assistant Professor"
            qualification="MBA (Project Management), Bachelor of Engineering (Information Technology)."
            specialization="Web Development, Angular, Project Management, SAP ABAP with SAP Netviewer 7.5"
            researchArea="-"
            totalExperience="2.5 Years"
            industryExperience="02 Years"
            teachingExperience="05 Months"
            papersPublished={{ total: 1, national: 1, international: "Nil" }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total:"Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        {/* <div>
          <FacultyCard
            img={manoj}
            name="Prof. Dr. Manoj Sathe"
            designation="Associate Professor"
            qualification="Ph.D (Computer Science), M.C.A, M.B.S, P.G.D.B.M."
            specialization="IT"
            mailId="sathe.manoj@gmail.com"
            researchArea="Data Science and Machine Learning"
            totalExperience="19 Years"
            industryExperience="1.5 Years"
            teachingExperience="18 Years"
            papersPublished={{ total: 10, national: 6, international: 4 }}
            booksPublished={{ total: 7, national: 3, international: 4 }}
            researchGuidance={{
              total: 0,
              completed: 0,
              pursuing: 0,
              patents: 2,
            }}
            googleScholarId="https://scholar.google.com/citations?user=ujcBVt4AAAAJ&hl=en"
          />
        </div> */}
        <div>
          <FacultyCard
            img={mahesh_sasane}
            name="Prof. Mahesh R.Sananse"
            designation="Assistant Professor"
            qualification="MCA (Engineering) Bsc (Computer Science)"
            specialization="Python Programming, Artificial Intelligence, Machine Learning, Data Science, Programming Principles"
            researchArea="-"
            totalExperience="1.4 Years"
            industryExperience="05 Months"
            teachingExperience="09 Months"
            papersPublished={{
              total: "05",
              national: "Nil",
              international: "05",
            }}
            booksPublished={{
              total: "02",
              national: "Nil",
              international: "02",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={shilpa}
            name="Prof. Shilpa Rathod"
            designation="Assistant Professor"
            qualification="MCA (Computer Application), BCA."
            specialization="Web Development, Java, Python Programming, Cloud Computing."
            researchArea="-"
            totalExperience="2.1 Years"
            industryExperience="08 Months"
            teachingExperience="1.5 Years"
            papersPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "N/A",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        {/* <div>
          <FacultyCard
            img={anil}
            name="Prof. Anil Phalke"
            designation="Assistant Professor"
            qualification="PhD (Pursuing),MCA (Computer Application) MBA (Marketing),B.Sc."
            specialization="C Programming, C++, Data Structure, Java, Advance Java"
            researchArea="LMS"
            totalExperience="14 Years"
            industryExperience="Nil"
            teachingExperience="14 Years"
            papersPublished={{
              total: "01",
              national: "01",
              international: "Nil",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: "Nil",
              completed:"Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div> */}
        <div>
          <FacultyCard
            img={monica}
            name="Prof. Monica Mali"
            designation="Assistant Professor"
            qualification="M.Sc( Computer Science),B.Sc(CS)"
            specialization="Web Technology"
            researchArea="Artificial Intelligence & Machine"
            totalExperience="7 Years"
            industryExperience="02 Years"
            teachingExperience="5 Years"
            papersPublished={{
              total: "04",
              national: "Nil",
              international: "04",
            }}
            booksPublished={{
              total: "02",
              national: "Nil",
              international: "02",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing:"Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        {/* <div>
          <FacultyCard
            img={uma}
            name="Mrs. Nidhi Ninad Damle"
            designation=""
            qualification="M.C.A, BCA, D.CS"
            specialization="Computer Management"
            mailId="ujupatil@gmail.com"
            researchArea="Data Analytics"
            totalExperience="6 Years"
            industryExperience="Nil"
            teachingExperience="06 Years"
            papersPublished={{
              total: "02",
              national: "02",
              international: "Nil",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: 0,
              completed: "N/A",
              pursuing: "N/A",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div> */}
        {/* <div>
          <FacultyCard
            img={yogeshwari}
            name="Prof.Yogeshwari Anand Mahajan"
            designation="Assistant Professor"
            qualification="MCA"
            specialization=""
            mailId="yogeshwariamahajan@gmail.com"
            researchArea=""
            totalExperience="2+"
            industryExperience=""
            teachingExperience=""
            papersPublished={{ total: 0, national: 0, international: 0 }}
            booksPublished={{ total: "Nil", national: 0, international: 0 }}
            researchGuidance={{
              total: 0,
              completed: 0,
              pursuing: 0,
              patents: "Nil",
            }}
            googleScholarId=""
          />
        </div> */}
      </div>
    </div>
  );
}

export function TeachingMBA() {
  return (
    <div className="bg-light m-0 px-3 pb-3">
      <h5 className="title-text py-4">Teaching Faculty MBA</h5>
      <div>
        <div>
          <FacultyCard
            img={mandakini}
            name="Prof. Dr. Ms. Mandakini R. Bhosale"
            designation="Associate Professor"
            qualification="PhD(HRM), MMS(HRM), M.Com, PGDHM, B.Ed(commerce)"
            specialization="Human Resource Management"
            mailId="mandakinibhosale@gmail.com"
            researchArea="Human Resource Management"
            totalExperience="30 Years"
            industryExperience="Nil"
            teachingExperience="30 Years"
            papersPublished={{
              total: "21",
              national: "13",
              international: "08",
            }}
            booksPublished={{ total: 1, national: 1, international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="https://scholar.google.co.in/citations?user=4s33oPsAAAAJ&hl=en"
          />
        </div>
        <div>
          <FacultyCard
            img={sudarshan_pawar}
            name="Prof. Dr. Sudarshan A. Pawar"
            designation="Institute Coordinator, Professor"
            qualification="NET (Management), PhD (Mkt. Mgmt), MBA (Mkt), BA (Eco)"
            specialization="Marketing Specialization"
            // mailId="sapawarmibs@gmail.com"
            researchArea="Consumer Buying Behaviour, Branding, Promotion"
            totalExperience="16 Years"
            industryExperience="1 Years"
            teachingExperience="15 Years"
            papersPublished={{
              total: "20",
              national: "7",
              international: "13",
            }}
            booksPublished={{ total: 3, national: 3, international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "03",
              patents: "Nil",
            }}
            googleScholarId="https://scholar.google.com/citations?hl=en&user=4ezgFlQAAAAJ"
          />
        </div>
        <div>
          <FacultyCard
            img={mahesh}
            name="Prof. Mahesh Salvi"
            designation="Assistant Professor"
            qualification="MCM, MBA(IT), MMS, Ph.D(Pursuing)"
            specialization="Information Technology"
            // mailId="salvimk@gmail.com"
            researchArea="New Education Policy"
            totalExperience="25 Years"
            industryExperience="04 Years"
            teachingExperience="21 Years"
            papersPublished={{
              total: "05",
              national: "03",
              international: "02",
            }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
            // googleScholarId="https://scholar.google.com/citations?user=ujcBVt4AAAAJ&hl=en"
          />
        </div>

        <div>
          <FacultyCard
            img={prasad}
            name="Prof. Dr. Prasad Ghodke"
            designation="Associate Professor"
            // qualification="-"
            qualification="MBA (Financial Management) Ph.D (Financial Management)"
            specialization="Financial Management"
            // mailId="prasadsppu2@gmail.com"
            researchArea="Financial management of micro & small scale industries"
            totalExperience="09 Years"
            industryExperience="01 Year"
            teachingExperience="08 Years"
            papersPublished={{
              total: "13",
              national: "04",
              international: "09",
            }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="https://scholar.google.com/citations?view_op=list_works&hl=en&hl=en&user=OoGu1N0AAAAJ"
          />
        </div>
        <div>
          <FacultyCard
            img={darshan}
            name="Prof. Darshan S Mejari"
            designation="Assistant Professor"
            qualification="M.com & M.B.A."
            specialization="Marketing & Human Resource Management"
            // mailId="mejari.darshan@gmail.com"
            researchArea="Marketing Mangement"
            totalExperience="24 Years"
            industryExperience="06 Years"
            teachingExperience="18 Years"
            papersPublished={{ total: 2, national: 1, international: 1 }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={neha_gupte}
            name="Prof. Neha R. Gupte"
            designation="Assistant Professor"
            qualification="BMS (Marketing), MMS (HRM), JLPT N5, N3; Pursuing PhD (HRM)"
            specialization="Human Resource, Foreign Language (Japanese Language)"
            // mailId="placementmibs91@gmail.com"
            researchArea="HRM & Cross-Cultural Environment"
            totalExperience="09 Years"
            industryExperience="02 Years"
            teachingExperience="04 Years(Academics), 03 Years(Freelancing)"
            papersPublished={{ total: 1, national: "Nil", international: 1 }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="E6VHlF8AAAAJ"
          />
        </div>
        <div>
          <FacultyCard
            img={rupali}
            name="Prof. Rupali Jadhav"
            designation="Assistant Professor"
            qualification="Ph.D(Pursuing), M.B.A, M.C.A, M.C.M"
            specialization="Marketing Management and Human Resource Management"
            // mailId="rupali.jadhav2385@gmail.com"
            researchArea="Marketing Management"
            totalExperience="10 Years"
            industryExperience="0 Years"
            teachingExperience="10 Years"
            papersPublished={{ total: 2, national: 1, international: 1 }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
         <div>
          <FacultyCard
            img={manojYawalkar}
            name="Prof. Manoj Shriram Yawalkar"
            designation="Assistant Professor"
            qualification="MMS(Fin), MMS (Comp Mgt), PGDBM (Gen. Mgt.), MCM, BCS"
            specialization="General Management"
            mailId="manojyawalkar2009@gmail.com"
            researchArea="General Management"
            totalExperience="30 Years"
            industryExperience="05 Years"
            teachingExperience="20 Years"
            papersPublished={{
              total: "14",
              national: "10",
              international: "05",
            }}
            booksPublished={{ total: "01", national: 1, international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={madhuri}
            name="Prof. Madhuri Dambal"
            designation="Assistant Professor"
            qualification="PhD (Pursuing), Company Secretary (ICSI), PGDBA (Financial Management), M. Com, B. Com (Finance & Taxation)"
            specialization="Financial Management"
            // mailId="madhuridambal5@gmail.com"
            researchArea="Financial Management"
            totalExperience="14 Years"
            industryExperience="10 Years"
            teachingExperience="04 Years"
            papersPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            booksPublished={{ total: "Nil", national: "Nil", international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={sonal}
            name="Prof. Ms. Sonal S. Tejwani"
            designation="Assistant Professor"
            qualification="Ph.D ( Pursuing ), MBA , B.Com, Qualified for MH-SET Examination"
            specialization="Financial Management"
            // mailId="sonaltejwani3110@gmail.com"
            researchArea="Financial Management"
            totalExperience="03 Years"
            industryExperience="01 Year"
            teachingExperience="02 Year"
            papersPublished={{ total: "3", national: 2, international: 1 }}
            booksPublished={{ total: "1", national: 1, international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div>
        <div>
          <FacultyCard
            img={smita_sonavane}
            name="Prof. Smita Prashant Sonawane"
            designation="Assistant Professor"
            qualification="Ph.D. (Pursuing), MBA, B.Sc. (Statistics)"
            specialization="Financial Management"
            // mailId="smitasonawane01@gmail.com"
            researchArea="Financial Management"
            totalExperience="09 Years 10 Months"
            industryExperience="Nil"
            teachingExperience="09 Years 10 Months"
            papersPublished={{
              total: "05",
              national: "02",
              international: "03",
            }}
            booksPublished={{ total: 3, national: 3, international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "02",
            }}
            googleScholarId="C68AAAAJ" // You can add the Google Scholar ID if available
          />
        </div>
        <div>
          <FacultyCard
            img={priyanka_sonavane}
            name="Prof. Priyanka Sonawane"
            designation="Assistant Professor"
            qualification="MBA (Operations Management), Bachelor of Engineering (Information Technology)"
            specialization="Operations management, Logistics Management, Data"
            // mailId="smitasonawane01@gmail.com"
            researchArea="Data Science, Blockchain, Logistics Management"
            totalExperience="4.5 Years"
            industryExperience="3.5 Year"
            teachingExperience="1+ Year"
            papersPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            booksPublished={{
              total: "Nil",
              national: "Nil",
              international: "Nil",
            }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-" // You can add the Google Scholar ID if available
          />
        </div>
        {/* <div>
          <FacultyCard
            img={amruta}
            name="Prof. Dr. Amruta Mandar Khedkar"
            designation="Assistant Professor"
            qualification="PhD, MCM, M.com, B.com(CA)"
            specialization="General Management, Business Analytics"
            mailId="khedkaramruta02@gmail.com"
            researchArea="Business Management"
            totalExperience="8 Years"
            industryExperience="0 Years"
            teachingExperience="8 Years"
            papersPublished={{ total: "2/5", national: 2, international: 5 }}
            booksPublished={{ total: "Nil", national: 0, international: 0 }}
            researchGuidance={{
              total: 6,
              completed: 0,
              pursuing: 0,
              patents: "Nil",
            }}
            googleScholarId="https://scholar.google.com/citations?user=HezK_Q4AAAAJ&hl=en"
          />
        </div> */}

        {/* <div>
          <FacultyCard
            img={manojYawalkar}
            name="Prof. Manoj Shriram Yawalkar"
            designation="Assistant Professor"
            qualification="MMS(Fin), MMS (Comp Mgt), PGDBM (Gen. Mgt.), MCM, BCS"
            specialization="General Management"
            mailId="manojyawalkar2009@gmail.com"
            researchArea="General Management"
            totalExperience="30 Years"
            industryExperience="05 Years"
            teachingExperience="20 Years"
            papersPublished={{
              total: "14",
              national: "10",
              international: "05",
            }}
            booksPublished={{ total: "01", national: 1, international: "Nil" }}
            researchGuidance={{
              total: "Nil",
              completed: "Nil",
              pursuing: "Nil",
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div> */}
        {/* <div>
          <FacultyCard
            img={komal}
            name="Prof. Mrs. Komal H. Apte  "
            designation="Assistant Professor"
            qualification="M.B.A (Marketing), UGC NET qualified"
            specialization="Marketing"
            mailId="gpta.komal@gmail.com"
            researchArea="Financial Products Marketing"
            totalExperience="6 Years"
            industryExperience="5 Years"
            teachingExperience="1 Year"
            papersPublished={{ total: 0, national: 0, international: 0 }}
            booksPublished={{ total: "Nil", national: 0, international: 0 }}
            researchGuidance={{
              total: 0,
              completed: 0,
              pursuing: 0,
              patents: "Nil",
            }}
            googleScholarId="-"
          />
        </div> */}
      </div>
    </div>
  );
}

export function NonTeaching() {
  return (
    <div className="bg-light m-0 px-3 pb-3">
      <h5 className="title-text py-4">Non-Teaching Faculty</h5>
      <div>
        <NonTeachingFacultyCard
          img={prashant}
          name="Mr. Prashant Markale"
          designation="Office Superintendent"
          qualification="L.L.B., M.A. "
          specialization="Law"
          // mailId="prashantmarkalepune@gmail.com"
          totalExperience="14 Years"
        />
      </div>
      <div>
        <NonTeachingFacultyCard
          img={Santosh_bagav}
          name="Mr. Santosh Bhanudas Bagav "
          designation="Librarian"
          qualification="M.A, MLISc. SET, Ph.D. (Pursuing )"
          specialization="Knowledge Organisation Information Processing, Coastal Geomorphology Fluvial Geomorphology"
          // mailId="santoshbagav4@gmail.com"
          totalExperience="09Years"
        />
      </div>
      <div>
        <NonTeachingFacultyCard
          img={aruna}
          name="Mrs. Aruna Umesh Kawathekar"
          designation="Asst. Librarian"
          qualification="M.Com,M.Lib I.sc ,M.Phil,LTC"
          specialization="Library Science "
          // mailId="kawathekarau@gmail.com"
          totalExperience="27 Years"
        />
      </div>
      <div>
        <NonTeachingFacultyCard
          img={sneha_padhey}
          name="Ms. Snehal  Rahul Padhye"
          designation="Accounts Clerk"
          qualification="B. Com,D.B.M"
          specialization="Accounting"
          // mailId="padhyesnehal2174@gmail.com"
          totalExperience="20 Years"
        />
      </div>
      <div>
        <NonTeachingFacultyCard
          img={swati_gadhve}
          name="Mrs. Swati Kantilal Gadhave"
          designation="Junior Clerk"
          qualification="M.Com, B.Com"
          specialization="Accounting and Finance"
          // mailId="swatinakure201@gmail.com"
          totalExperience="12 Years"
        />
      </div>
      {/* <div>
        <NonTeachingFacultyCard
          img={anita_deshmane}
          name="Mrs. Anita Yogesh Deshmane"
          designation="Junior Clerk"
          qualification="M.Com, B.Com"
          specialization="Accounting"
          // mailId="swatinakure201@gmail.com"
          totalExperience="12 Years"
        />
      </div> */}
      <div>
        <NonTeachingFacultyCard
          img={urmlia_patil}
          name="Mrs. Urmila Vaibhav Patil"
          designation="Junior Clerk"
          qualification="B.C.A"
          specialization="Computer Application"
          // mailId="swatinakure201@gmail.com"
          totalExperience="10 Years"
        />
      </div>
      {/* <div>
        <NonTeachingFacultyCard
          img={megha}
          name="Mrs. Megha S.Satav"
          designation="Junior Clerk"
          qualification="M.Com"
          specialization="Accounting"
          mailId="satavmegha@gmail.com"
          totalExperience="25 Years"
        />
      </div>
     
      
      <div>
        <NonTeachingFacultyCard
          img={mrudula}
          name="Ms. Mrudula J Madiwale"
          designation="Asst. Librarian"
          qualification="M.Lib & ISc, B.Ed. , M.A."
          specialization="Library and Information Science"
          mailId="mridulamadiwale@yahoo.com"
          totalExperience="15 Years"
        />
      </div>
    
      <div>
        <NonTeachingFacultyCard
          img={akanksha}
          name="Ms. Akanksha Todarmal"
          designation="Junior Clerk"
          qualification="M.Sc (Chemistry)"
          specialization="Accounting"
          mailId="akankshastoradmal@gmail.com"
          totalExperience="2 Years"
        />
      </div> */}
    </div>
  );
}
